import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const apiError = (e, fallback = "Une erreur est survenue") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((x) => (x && typeof x.msg === "string" ? x.msg : "")).filter(Boolean).join(" ");
  return fallback;
};

export const mediaUrl = (u) =>
  u && u.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u;

export default api;
